export function groupCount(
  indices: Uint32Array,
  accessor: (i: number) => number,
  bucketCount: number,
): Uint32Array {
  const out = new Uint32Array(bucketCount);
  for (let k = 0; k < indices.length; k++) {
    const v = accessor(indices[k]);
    if (v >= 0 && v < bucketCount) out[v]++;
  }
  return out;
}
